export default {
  independentMarketing: {
    common: {
      requestFailed: 'درخواست رابط ناموفق بود',
      hintSelect: 'انتخاب کنید',
      hintInput: 'وارد',
      submit: 'ارسال',
      cancel: 'لغو کنید',
      confirm: 'خوب',
    },
    agreement: {
      title: 'قرارداد ثبت نمایندگی مستقل Autel',
      nextBtn: 'بعد',
      getAgreementFailed: '.محتوای توافق دریافت نشد',
    },
    successPage: {
      title:
        '.اطلاعات درخواست شما با موفقیت ارسال شد و نتایج بررسی ظرف 15 روز کاری به ایمیل $1 شما ارسال خواهد شد. لطفا برای اطلاعات بیشتر صندوق ورودی خود را بررسی کنید',
      subTitle: 'بعد از $1 ثانیه به صفحه اصلی بازگردید.',
    },
    applyTitle: 'شما برای تبدیل شدن به یک فروشنده مستقل Autel درخواست می دهید. لطفا اطلاعات زیر را به دقت تکمیل کنید:',
    companyName: 'نام شرکت',
    companyTax: 'شناسه مالیات بر ارزش افزوده',
    userCountry: 'کشور',
    legalPerson: 'مشاور حقوقی',
    contactEmail: 'تماس با ایمیل',
    contactEmailTips:
      '.این آدرس ایمیل، ایمیل نتیجه بررسی مخاطب شما خواهد بود. پس از تأیید بررسی، به عنوان نام حساب ورود به سیستم مدیریت فروشنده مستقل نیز استفاده خواهد شد',
    corporateIdentity: 'شناسه مشاور حقوقی',
    uploadTips: 'JPG، JPEG، PNG، PDF (حداکثر 20 مگابایت)',
    businessLicense: 'مجوز داد و ستد',
    emailErrorTips: '.یک ایمیل معتبر وارد کنید',
    uploadPic: 'آپلود تصاویر',
    picMaxLimit: '.حداکثر حجم تصویر 20 مگابایت است. لطفاً دوباره انتخاب کنید',
  },
};
